import script from "./BenchmarkSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenchmarkSection.vue?vue&type=script&setup=true&lang=ts"

import "./BenchmarkSection.vue?vue&type=style&index=0&id=fc01b25a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc01b25a"]])

export default __exports__